// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oi-1";
export var stateContainer = "_oi-0";